import * as React from 'react';
import { classes, style } from 'typestyle';
import { px } from 'csx';
import { YouTubeVideoTrackTile } from './YouTubeVideoTrackTile';
import { mediaUpToDesktop } from '../utilities/mediaQueries';
import { BaseCarouselSlice } from '../organisms/slices/BaseCarouselSlice';
import { DecoratedPageCarousel } from '../organisms/DecoratedPageCarousel';
import { FeaturedVideo } from '../utilities/types';

const styles = {
  carouselTile: style(mediaUpToDesktop({ maxWidth: px(380) })),
};

export type YouTubeVideoTrackCarouselProps = { className?: string; videos: FeaturedVideo[]; heading: string };

export const YouTubeVideoTrackCarousel: React.FC<YouTubeVideoTrackCarouselProps> = ({ className, videos, heading }) => {
  if (!videos.length) return null;

  return (
    <BaseCarouselSlice>
      <DecoratedPageCarousel
        className={classes(className)}
        tileClassName={styles.carouselTile}
        perPage={3}
        mobileTileSize={90}
        heading={heading}
        indicatorAlignment="centre"
      >
        {videos.map((video) => (
          <YouTubeVideoTrackTile key={video.youtube_video_id} video={video} />
        ))}
      </DecoratedPageCarousel>
    </BaseCarouselSlice>
  );
};
